import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

export const useBeforeRouteChange = (beforeUnloadHandler: VoidFunction) => {
  const { pathname } = useLocation();
  useEffect(() => {
    return () => {
      beforeUnloadHandler();
    };
  }, [pathname]);
};
